module.exports = __webpack_public_path__ + "static/measuretext-e20fd1b516efe0d4ed666b128392b18e.jpg";